window.axios = require('axios');
window.moment = require('moment');
window.moment.locale('pt-br');

import Fragment from "vue-fragment";
import Vue from 'vue';
import VueProgressBar from 'vue-progressbar'
import App from './App.vue';
import router from './router';
import store from './store';
import vuetify from './plugins/vuetify';
import VueTheMask from 'vue-the-mask';
import './filters.js';
import './axios.js';
import './assets/sass/bootstrap-reboot.min.css';
import './assets/sass/reset.css';
import './assets/sass/normalize.css';
import './assets/sass/bootstrap-grid.min.css';
import './assets/sass/bootstrap.min.css';
import GlobalMethods from './mixins/GlobalMethods';
// import './registerServiceWorker'

Vue.directive('mask', VueTheMask);
Vue.use(Fragment.Plugin);
Vue.use(VueProgressBar, {
  color: '#e72c1f',
  failedColor: '#e72c1f',
  thickness: '5px',
  autoRevert: true,
  autoFinish: false,
});
Vue.use(VueTheMask);
Vue.config.productionTip = false;

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app');

Vue.mixin(GlobalMethods);
